import React from 'react';
import {
  PERM_GROUPS, PROFILI, SOLO_ADMIN, tutteLeChiavi, voceSpenta, avvisiPermessi, profiloUguale,
} from '../perms';

const TOTALE = tutteLeChiavi().length;

function Lucchetto() {
  return (
    <svg className="perm-lock" viewBox="0 0 16 16" width="13" height="13" aria-hidden="true">
      <rect x="3" y="7" width="10" height="7" rx="1.6" fill="none" stroke="currentColor" strokeWidth="1.5" />
      <path d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2" fill="none" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
}

/* Selettore permessi. Gruppi nello stesso ordine del menu a sinistra; sotto ogni voce una
   riga dice cosa accende oltre alla pagina. I widget della Dashboard si ingrigiscono senza
   la Dashboard. In cima i profili pronti (un clic sostituisce la selezione), in fondo
   quello che resta dell'amministratore. */
export default function PermessiSelector({ value, onChange }) {
  const scelti = value || [];
  const sel = new Set(scelti);
  const toggle = (k) => {
    const next = new Set(sel);
    if (next.has(k)) next.delete(k); else next.add(k);
    onChange([...next]);
  };
  const avvisi = avvisiPermessi(scelti);

  return (
    <div className="perm-sel">
      <div className="perm-profili">
        <span className="perm-profili-lbl">Profili</span>
        {PROFILI.map((p) => (
          <button key={p.nome} type="button"
                  className={`perm-profilo${profiloUguale(p, scelti) ? ' on' : ''}`}
                  onClick={() => onChange([...p.permessi])}>
            {p.nome}
          </button>
        ))}
        <button type="button" className="perm-profilo perm-profilo--vuoto" onClick={() => onChange([])}>
          Nessuna voce
        </button>
        <span className="perm-conta">{sel.size} di {TOTALE} voci</span>
      </div>

      {avvisi.length > 0 && (
        <ul className="perm-avvisi" role="status">
          {avvisi.map((a) => <li key={a}>{a}</li>)}
        </ul>
      )}

      <div className="perm-grid">
        {COLONNE.map((titoli) => (
          <div key={titoli.join()} className="perm-colonna">
            {titoli.map((t) => (t === ADMIN ? <GruppoAdmin key={t} /> : (
              <Gruppo key={t} g={PERM_GROUPS.find((x) => x.titolo === t)} scelti={scelti} sel={sel} toggle={toggle} />
            )))}
          </div>
        ))}
      </div>
    </div>
  );
}

// Tre colonne fisse, nell'ordine del menu, impilate senza buchi e di altezza simile.
const ADMIN = 'Solo amministratore';
const COLONNE = [
  ['Generale', 'Strumenti nel menu AI'],
  ['Agenti', 'Lavoro'],
  ['Impostazioni', ADMIN],
];

function Gruppo({ g, scelti, sel, toggle }) {
  return (
    <div className="perm-group">
      <div className="perm-group-title">{g.titolo}</div>
      {g.voci.map((v, i) => {
        const spenta = voceSpenta(v, scelti);
        const nuovaSezione = v.sezione && v.sezione !== g.voci[i - 1]?.sezione;
        return (
          <React.Fragment key={v.key}>
            {nuovaSezione && <div className="perm-sezione">{v.sezione}</div>}
            <label className={`perm-item${v.dipende ? ' perm-item--figlia' : ''}${spenta ? ' spenta' : ''}`}
                   title={spenta ? 'Serve prima la Dashboard' : undefined}>
              <input type="checkbox" checked={sel.has(v.key)} disabled={spenta}
                     onChange={() => toggle(v.key)} />
              <span className="perm-testo">
                <span>{v.label}</span>
                {v.nota && <span className="perm-nota">{v.nota}</span>}
              </span>
            </label>
          </React.Fragment>
        );
      })}
    </div>
  );
}

function GruppoAdmin() {
  return (
    <div className="perm-group perm-group--admin">
      <div className="perm-group-title"><Lucchetto /> {ADMIN}</div>
      <div className="perm-admin-voci">
        {SOLO_ADMIN.map((nome) => <span key={nome} className="perm-admin-voce">{nome}</span>)}
      </div>
      <div className="perm-nota perm-nota--admin">Non si assegnano: le usa solo l’amministratore.</div>
    </div>
  );
}
